// extracted by mini-css-extract-plugin
module.exports = {"container":"wysiwyg-styles_container__9bh1Y"};